import { useSelector } from 'react-redux';

export const usePermission = () => {
  const user = useSelector((state) => state?.user?.user);
  const userPermissions = user?.roleId?.permissions || user?.permissions || {};
  const isOwner = user?.role === "owner" || user?.isOwner === true;

  /**
   * பர்மிஷன் உள்ளதா எனச் சரிபார்க்கும் செயல்பாடு
   * @param {string} moduleKey - எ.கா: "sales:leads"
   * @param {string} action - "view" | "add" | "edit" | "delete" | "export"
   */
  const hasPermission = (moduleKey, action = "view") => {
    if (isOwner) return true; // Owner கணக்கிற்கு எப்போதும் முழு அனுமதி உண்டு
    return !!userPermissions[moduleKey]?.[action];
  };

  return { hasPermission, isOwner, user };
};